<template>
<div>
  <head>
    <title>{{obj.nome}}</title>
    <link rel="icon" :href="obj.logo" />
  </head>

  <nav class="white">
    <div v-if="loading" class="preloader-wrapper active d-block mx-auto" style="top: 30px">
      <div class="spinner-layer spinner-blue-only">
        <div class="circle-clipper left">
          <div class="circle"></div>
        </div>
        <div class="gap-patch">
          <div class="circle"></div>
        </div>
        <div class="circle-clipper right">
          <div class="circle"></div>
        </div>
      </div>
    </div>

    <div v-else class="nav-wrapper">
    

      <router-link to="#" data-target="slide" class="sidenav-trigger show-on-medium-and-down">
          <img
        class="logoMobile  show-on-medium-and-down"
        src="../assets/img/Logo.png"
        alt
      />
        <i class="material-icons center icon-menu" style="color:#000">menu</i>
      </router-link>

      <ul id="nav-mobile" class="hide-on-med-and-down right-align">
        <router-link :to="'/'">
          <img class="brand-logo" src="../assets/img/Logo.png" alt />
        </router-link>
        <li v-bind:class="[ this.$route.path == '/login' ? 'pgAtual' : '']">
          <router-link
            v-show="client == false"
            to="/login"
          >LOGIN</router-link>
          <router-link
            data-target="slide-out"
            class="sidenav-trigger hide-on-med-and-down"
            to="#"
            v-if="client != false"
          >PERFIL</router-link>
        </li>
        <li v-bind:class="[ this.$route.path == '/cadastro' ? 'pgAtual' : '']">
          <a
            v-show="client == false"
            href="/cadastro"
          >FAÇA PARTE</a>
          <router-link :to="'/beneficios'" v-if="client != false">BENEFÍCIOS</router-link>
        </li>
        <li v-bind:class="[ this.$route.path == '/regulamento' ? 'pgAtual' : '']">
          <router-link :to="'/regulamento'">REGRAS E DÚVIDAS</router-link>
        </li>
        <li>
          <a target="_blank" href="https://www.trilhacervejaria.com.br/home">A TRILHA</a>
        </li>
        <li>
          <a
            target="_blank"
            href="https://loja.trilhacervejaria.com.br/?_ga=2.81744277.341039212.1574341835-1931649034.1568741697"
          >LOJA</a>
        </li>
        <li>
          <a target="_blank" href="https://www.trilhacervejaria.com.br/barrelclub">BARREL CLUB</a>
        </li>
        <li>
          <a target="_blank" href="http://www.trilhacervejaria.info/">CURSOS</a>
        </li>
        <li>
          <a target="_blank" href="https://www.trilhacervejaria.com.br/blog">BLOG</a>
        </li>
      </ul>
    </div>
  </nav>

  <ul id="slide-out" class="sidenav sidenav-close">
    <li>
      <div class="user-view" v-show="client != false">
        <img v-if="client.foto != null && client.foto != ''" class="circle" :src="client.foto" />
        <img v-else class="circle" src="../assets/no_avatar.jpg" />
        <div class="background" style="background-color: #f8f8f8"></div>
        <span>
          <p>{{client.nome}}</p>
          <p
            v-if="obj.habilitar_pontuacao_inteira"
          >{{parseInt(client.saldo).toLocaleString('pt-BR')}} pontos</p>

          <p
            v-else
          >{{parseFloat(client.saldo).toFixed(2).replace('.',',').toLocaleString('pt-BR')}} pontos</p>
        </span>
        <p>{{client.email}}</p>
      </div>
    </li>
    <li>
      <router-link v-show="client != false" :to="'/meus-dados'">Meus dados</router-link>
    </li>
    <li>
      <router-link v-show="client != false" :to="'/meus-pontos'">Meus pontos</router-link>
    </li>
    <li>
      <router-link v-show="client != false" :to="'/meus-resgates'">Meus resgates</router-link>
    </li>
    <li>
      <router-link v-show="client != false" :to="'/meus-presentes'">Meus presentes</router-link>
    </li>
    <li>
      <router-link v-show="client != false" :to="'/codigo-pontuavel'">Inserir código</router-link>
    </li>
    <li>
      <router-link v-show="client != false" :to="'/indique'">Indique amigos</router-link>
    </li>
    <li>
      <a href="#" class="click" to="#" v-show="client != false" @click="logout()">Sair</a>
    </li>
  </ul>

  <ul id="slide" class="sidenav sidenav-close">
    <li>
      <div class="user-view" v-show="client != false">
        <img v-if="client.foto != null && client.foto != ''" class="circle" :src="client.foto" />
        <img v-else class="circle" src="../assets/no_avatar.jpg" />
        <div class="background" style="background-color: #f8f8f8"></div>
        <span>
          <p>{{client.nome}}</p>
          <p
            v-if="obj.habilitar_pontuacao_inteira"
          >{{parseInt(client.saldo).toLocaleString('pt-BR')}} pontos</p>

          <p
            v-else
          >{{parseFloat(client.saldo).toFixed(2).replace('.',',').toLocaleString('pt-BR')}} pontos</p>
        </span>
        <p>{{client.email}}</p>
      </div>
    </li>
    <li @click="clear()">
      <router-link :to="'/'">HOME</router-link>
    </li>
    <li v-bind:class="[ this.$route.path == '/login' ? 'pgAtual' : '']">
      <router-link
        v-show="client == false"
        to="/login"
      >LOGIN</router-link>
      <router-link
        data-target="slide-out"
        class="sidenav-trigger hide-on-med-and-down"
        to="#"
        v-if="client != false"
      >PERFIL</router-link>
    </li>
    <li v-bind:class="[ this.$route.path == '/cadastro' ? 'pgAtual' : '']">
      <a
        v-show="client == false"
        href="https://trilha-cervejaria.xtechcommerce.com/secure/register"
      >FAÇA PARTE</a>
      <router-link :to="'/beneficios'" v-if="client != false">BENEFÍCIOS</router-link>
    </li>
    <li v-bind:class="[ this.$route.path == '/regulamento' ? 'pgAtual' : '']">
      <router-link :to="'/regulamento'">REGRAS E DÚVIDAS</router-link>
    </li>
    <li>
      <a target="_blank" href="https://www.trilhacervejaria.com.br/home">A TRILHA</a>
    </li>
    <li>
      <a
        target="_blank"
        href="https://loja.trilhacervejaria.com.br/?_ga=2.81744277.341039212.1574341835-1931649034.1568741697"
      >LOJA</a>
    </li>
    <li>
      <a target="_blank" href="https://www.trilhacervejaria.com.br/barrelclub">BARREL CLUB</a>
    </li>
    <li>
      <a target="_blank" href="http://www.trilhacervejaria.info/">CURSOS</a>
    </li>
    <li>
      <a target="_blank" href="https://www.trilhacervejaria.com.br/blog">BLOG</a>
    </li>

    <li>
      <router-link v-show="client != false" :to="'/meus-dados'">Meus dados</router-link>
    </li>
    <li>
      <router-link v-show="client != false" :to="'/meus-pontos'">Meus pontos</router-link>
    </li>
    <li>
      <router-link v-show="client != false" :to="'/meus-resgates'">Meus Resgates</router-link>
    </li>
    <li>
      <router-link v-show="client != false" :to="'/meus-presentes'">Meus presentes</router-link>
    </li>
    <li>
      <router-link v-show="client != false" :to="'/codigo-pontuavel'">Inserir código</router-link>
    </li>
    <li>
      <router-link v-show="client != false" :to="'/indique'">Indique amigos</router-link>
    </li>
    <li>
      <a href="#" v-show="client != false" @click="logout()">Sair</a>
    </li>
  </ul>
</div>
</template>

<style lang="scss" scoped>
p {
  margin: 0;
  font-size: 12pt;
}
.brand-logo {
  left: 20px;
  top: 20px;
}

nav ul li {
  display: inline;
  float: none;
  white-space: nowrap;
}
//icon menu responsivo no centro
nav .sidenav-trigger {
  color: black;
  float: initial;
  .icon-menu{
    float: left;
  }
}

a {
  float: none;
  text-transform: uppercase !important;
}

#slide-out li a {
  font-size: 13pt;
}

.pgAtual {
  a {
    font-weight: bolder;
  }
}

#nav-mobile {
  padding-right: 10px;
  padding-top: 20px;
}

nav ul li a {
  display: inline-block;
  color: rgb(58, 56, 56);
  padding: 0 12px;
}
nav ul li a:hover {
  background: none;
  color: #afafaf;
}

nav {
  height: 100px;
  background-color: white !important;
  position: relative;
  .logoMobile {
    max-height: 37px;
    position: absolute;
    top: 12px;
    right: 50%;
    transform: translateX(50%);
  }
}

@media (max-width: 993px) {
  nav {
    height: 63px;
    background-color: #e3e3e3 !important;
  }
}

::-webkit-scrollbar {
  width: 2px;
}
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
::-webkit-scrollbar-thumb {
  background: #8a8b8b;
}
</style>

<script>
import { Donuz } from "donuz-js/Donuz";

export default {
  data() {
    return {
      obj: {},
      client: false,
      configs: {},
      loading: true
    };
  },
  mounted() {
    var elems = document.querySelectorAll(".sidenav");
    var instances = M.Sidenav.init(elems, {});
  },
  async created() {
    var elems = document.querySelectorAll(".sidenav");
    M.Sidenav.init(elems);
    var dropdowns = document.querySelectorAll(".dropdown-trigger");
    M.Dropdown.init(dropdowns, {});

    M.AutoInit();
    this.obj = await this.getAdmins();
    this.obj = this.obj.estabelecimentos[0];
    this.configs = await Donuz.settings.getSettings();
    this.configs = this.configs.configuracoes;

    if (sessionStorage.getItem(btoa("cliente")) != null) {
      this.client = JSON.parse(atob(sessionStorage.getItem(btoa("cliente"))));
    }
    this.loading = false;
  },
  methods: {
    logout: function() {
      this.client = false;
      sessionStorage.clear();
      location.href = this.baseUrl;
    },
    updateBalance: async function() {
      let result = await Donuz.balance.getCustomerBalance(
        sessionStorage.getItem(btoa("tokenCliente"))
      );
      if (result.status == 200) {
        this.client.saldo = result.saldo;
        sessionStorage.setItem(
          btoa("cliente"),
          btoa(JSON.stringify(this.client))
        );
      }
    }
  }
};
</script>


